import { Box, Container } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { useSettingsContext } from '../../components/settings';
import { Breadcrumbs } from './Breadcrumbs';
import { PlacementListNavigatorContextProvider } from './PlacementListNavigatorContext';
import { Tabs } from './Tabs';

export const PlacementListNavigator = () => {
  const { themeStretch } = useSettingsContext();

  return (
    <PlacementListNavigatorContextProvider>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Breadcrumbs />

        <Tabs />

        <Box>
          <Outlet />
        </Box>
      </Container>
    </PlacementListNavigatorContextProvider>
  );
};
